// extracted by mini-css-extract-plugin
export default {"contact":"ContactDetails_contact__zpnQj","container":"ContactDetails_container__somuO","icon":"ContactDetails_icon__HwMb7","logos":"ContactDetails_logos__orUqm"};